import controller from './carousel-banner.controller';
import templateBase from './templates/carousel-banner-base.view.html';

let CarouselBannerComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    cbItems : '<',
    cbName : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  return templateBase;

}

export default CarouselBannerComponent;



// WEBPACK FOOTER //
// ./www/components/shared/components/banners/carousel-banner/carousel-banner.component.js